import React from "react";
import { useTranslation } from "react-i18next";
import { LIFECYCLE_FILTERS } from "../../lib/platformValidation";

/**
 * Lifecycle filter for the organization list: Всички / Чакащи активация /
 * Активни / Архивирани / Чакащи изтриване.
 *
 * A filter is a view, never an authorization boundary — the backend clamps an
 * unknown value back to "all" rather than answering 422, so a stale bookmark
 * shows everything instead of an error.
 */
export const PlatformLifecycleFilter = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation();
  const active = LIFECYCLE_FILTERS.includes(value) ? value : "all";

  return (
    <div className="qw-life-filter" role="group" aria-label={t("platform.lifecycle_section")} data-testid="platform-lifecycle-filter">
      {LIFECYCLE_FILTERS.map((option) => (
        <button
          key={option}
          type="button"
          className={`qw-btn sm ${option === active ? "primary" : "ghost"}`}
          aria-pressed={option === active}
          disabled={disabled}
          onClick={() => onChange(option)}
          data-testid={`platform-lifecycle-filter-${option}`}
        >
          {t(`platform.filter_${option}`)}
        </button>
      ))}
    </div>
  );
};

export default PlatformLifecycleFilter;
